'use client'
import React from 'react'

export const AlignJustifyIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    className="icon"
    fill="none"
    focusable="false"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 5H17.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2.5 10H17.5" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2.5 15H17.5" stroke="currentColor" strokeWidth="1.5" />
  </svg>
)
